export const countries = ['GB', 'UK', 'US', 'CA', 'AU', 'NZ', 'DE', 'FR'];

export function getEnableAfter(url) {
    if (url.includes('/products/cloud/express-signup/')) {
        return 1000;
    }

    return 10 * 1000;
}

export const pageRegex = ['/products/', '/partners/', '/solutions/'].map(
    (reg) => new RegExp(reg, 'ig'),
);
